import EventsHelper from "../../common/js/eventsHelper";

export default new class AsideMenu {
    constructor() {
        this.menu = '.fs-aside-menu';
        this.menuId = 'asideMenu';
        this.menuCatalogId = 'asideMenuCatalog';
        this.menuCategoryId = 'asideMenuCategory';
        this.menuClose = '.fs-aside-menu--close';
        this.menuCatalogTitle = '.fs-aside-menu--title';
        this.menuCategoryTitle = '.fs-aside-menu--title.fs--category';
        this.catalog = '.fs-aside-menu--nav-link.fs--catalog';
        this.category = '.fs-aside-menu--nav-link.fs--parent';
        this.headerId = 'header';

        this.classOpen = 'fs--open';
        this.state = {
            isOpen: null,
        }

        this.catalogList = window['categoriesEncoded'];

        this.attachEvents()
    }

    attachEvents() {
        document.querySelector(this.catalog).addEventListener('click', this.handleOnCatalogClick);
        document.querySelectorAll(this.category).forEach(link => link.addEventListener('click', this.handleOnCategoryClick));
        document.querySelector(this.menuCatalogTitle).addEventListener('click', this.toggleAsideMenuCatalog);
    }

    attachCategoryEvents() {
        document.querySelector(this.menuCategoryTitle).addEventListener('click', this.closeAsideMenuCategory);
    }

    handleOnCatalogClick = e => {
        e.preventDefault();
        this.toggleAsideMenuCatalog();
    }

    toggleAsideMenuCatalog = () => {
        document.getElementById(this.menuCatalogId).classList.toggle(this.classOpen);
    }

    closeAsideMenuCategory = () => {
        let menu = document.getElementById(this.menuCategoryId);

        menu.classList.remove(this.classOpen);
        setTimeout(() => menu.remove(), 300)
    }

    animateMenuOpening() {
        let menu = document.getElementById(this.menuCategoryId);

        setTimeout(() => menu.classList.add(this.classOpen), 0);
    }

    openMenu() {
        document.getElementById(this.menuId).classList.add(this.classOpen);
        this.toggleScrollBar();
    }

    closeMenu() {
        document.querySelectorAll(this.menu).forEach(menu => {
            menu.classList.remove(this.classOpen);
            if (menu.id == this.menuCategoryId) menu.remove();
        });
        this.toggleScrollBar();
    }

    toggleScrollBar() {
        this.state.isOpen
            ? (EventsHelper.returnScrollBar(), this.state.isOpen = false)
            : (EventsHelper.hideScrollBar(), this.state.isOpen = true);
    }

    handleOnCategoryClick = e => {
        e.preventDefault();
        const link = e.currentTarget;
        const categoryId = link.getAttribute("data-id");
        const category = this.catalogList.find(item => item.id == categoryId)
        
        if (category) this.renderCategoryMenu(category);
    }

    renderCategoryMenu(category) {
        const header = document.getElementById(this.headerId);
        const categoryMenu = this.getCategoryMenu(category);

        header.insertAdjacentHTML('beforeend', categoryMenu);
        this.attachCategoryEvents();
        this.animateMenuOpening();
    }

    getCategoryMenu(category) {
        return (`
                <div class="fs-aside-menu" id="asideMenuCategory">
                <div class="fs-aside-menu--title fs--category">${category.name}</div>
                <ul class="fs-aside-menu--nav">
                    <li class="fs-aside-menu--nav-item">
                        <a class="fs-aside-menu--nav-link fs--main-link" href="/catalog/${category.slug}">Перейти в раздел</a>
                    </li>
                    ${category.children.map(this.getCategoryMenuItem).join('')}
                </ul>
            </div>
        `)
    }

    getCategoryMenuItem = item => {
        return (`
            <li class="fs-aside-menu--nav-item">
                <a class="fs-aside-menu--nav-link" href="/catalog/${item.parentSlug}/${item.slug}">
                    ${item.name}
                </a>
            </li>
        `)
    }

}